/**
 * Phone country codes data
 * n = country name, d = dial code, c = country code, e = emoji flag
 */
export type PhoneCode = { n: string; d: string; c: string; e: string };

export const phoneCodes: PhoneCode[] = [
  { n: 'Afghanistan', d: '+93', c: 'AF', e: '🇦🇫' },
  { n: 'Aland Islands', d: '+358', c: 'AX', e: '🇦🇽' },
  { n: 'Albania', d: '+355', c: 'AL', e: '🇦🇱' },
  { n: 'Algeria', d: '+213', c: 'DZ', e: '🇩🇿' },
  { n: 'American Samoa', d: '+1684', c: 'AS', e: '🇦🇸' },
  { n: 'Andorra', d: '+376', c: 'AD', e: '🇦🇩' },
  { n: 'Angola', d: '+244', c: 'AO', e: '🇦🇴' },
  { n: 'Anguilla', d: '+1264', c: 'AI', e: '🇦🇮' },
  { n: 'Antarctica', d: '+672', c: 'AQ', e: '🇦🇶' },
  { n: 'Antigua and Barbuda', d: '+1268', c: 'AG', e: '🇦🇬' },
  { n: 'Argentina', d: '+54', c: 'AR', e: '🇦🇷' },
  { n: 'Armenia', d: '+374', c: 'AM', e: '🇦🇲' },
  { n: 'Aruba', d: '+297', c: 'AW', e: '🇦🇼' },
  { n: 'Australia', d: '+61', c: 'AU', e: '🇦🇺' },
  { n: 'Austria', d: '+43', c: 'AT', e: '🇦🇹' },
  { n: 'Azerbaijan', d: '+994', c: 'AZ', e: '🇦🇿' },
  { n: 'Bahamas', d: '+1242', c: 'BS', e: '🇧🇸' },
  { n: 'Bahrain', d: '+973', c: 'BH', e: '🇧🇭' },
  { n: 'Bangladesh', d: '+880', c: 'BD', e: '🇧🇩' },
  { n: 'Barbados', d: '+1246', c: 'BB', e: '🇧🇧' },
  { n: 'Belarus', d: '+375', c: 'BY', e: '🇧🇾' },
  { n: 'Belgium', d: '+32', c: 'BE', e: '🇧🇪' },
  { n: 'Belize', d: '+501', c: 'BZ', e: '🇧🇿' },
  { n: 'Benin', d: '+229', c: 'BJ', e: '🇧🇯' },
  { n: 'Bermuda', d: '+1441', c: 'BM', e: '🇧🇲' },
  { n: 'Bhutan', d: '+975', c: 'BT', e: '🇧🇹' },
  { n: 'Bolivia', d: '+591', c: 'BO', e: '🇧🇴' },
  { n: 'Bosnia and Herzegovina', d: '+387', c: 'BA', e: '🇧🇦' },
  { n: 'Botswana', d: '+267', c: 'BW', e: '🇧🇼' },
  { n: 'Brazil', d: '+55', c: 'BR', e: '🇧🇷' },
  { n: 'British Indian Ocean Territory', d: '+246', c: 'IO', e: '🇮🇴' },
  { n: 'Brunei Darussalam', d: '+673', c: 'BN', e: '🇧🇳' },
  { n: 'Bulgaria', d: '+359', c: 'BG', e: '🇧🇬' },
  { n: 'Burkina Faso', d: '+226', c: 'BF', e: '🇧🇫' },
  { n: 'Burundi', d: '+257', c: 'BI', e: '🇧🇮' },
  { n: 'Cambodia', d: '+855', c: 'KH', e: '🇰🇭' },
  { n: 'Cameroon', d: '+237', c: 'CM', e: '🇨🇲' },
  { n: 'Canada', d: '+1', c: 'CA', e: '🇨🇦' },
  { n: 'Cape Verde', d: '+238', c: 'CV', e: '🇨🇻' },
  { n: 'Cayman Islands', d: '+345', c: 'KY', e: '🇰🇾' },
  { n: 'Central African Republic', d: '+236', c: 'CF', e: '🇨🇫' },
  { n: 'Chad', d: '+235', c: 'TD', e: '🇹🇩' },
  { n: 'Chile', d: '+56', c: 'CL', e: '🇨🇱' },
  { n: 'China', d: '+86', c: 'CN', e: '🇨🇳' },
  { n: 'Christmas Island', d: '+61', c: 'CX', e: '🇨🇽' },
  { n: 'Cocos (Keeling) Islands', d: '+61', c: 'CC', e: '🇨🇨' },
  { n: 'Colombia', d: '+57', c: 'CO', e: '🇨🇴' },
  { n: 'Comoros', d: '+269', c: 'KM', e: '🇰🇲' },
  { n: 'Congo', d: '+242', c: 'CG', e: '🇨🇬' },
  {
    n: 'Congo, The Democratic Republic of the Congo',
    d: '+243',
    c: 'CD',
    e: '🇨🇩',
  },
  { n: 'Cook Islands', d: '+682', c: 'CK', e: '🇨🇰' },
  { n: 'Costa Rica', d: '+506', c: 'CR', e: '🇨🇷' },
  { n: "Cote d'Ivoire", d: '+225', c: 'CI', e: '🇨🇮' },
  { n: 'Croatia', d: '+385', c: 'HR', e: '🇭🇷' },
  { n: 'Cuba', d: '+53', c: 'CU', e: '🇨🇺' },
  { n: 'Cyprus', d: '+357', c: 'CY', e: '🇨🇾' },
  { n: 'Czech Republic', d: '+420', c: 'CZ', e: '🇨🇿' },
  { n: 'Denmark', d: '+45', c: 'DK', e: '🇩🇰' },
  { n: 'Djibouti', d: '+253', c: 'DJ', e: '🇩🇯' },
  { n: 'Dominica', d: '+1767', c: 'DM', e: '🇩🇲' },
  { n: 'Dominican Republic', d: '+1849', c: 'DO', e: '🇩🇴' },
  { n: 'Ecuador', d: '+593', c: 'EC', e: '🇪🇨' },
  { n: 'Egypt', d: '+20', c: 'EG', e: '🇪🇬' },
  { n: 'El Salvador', d: '+503', c: 'SV', e: '🇸🇻' },
  { n: 'Equatorial Guinea', d: '+240', c: 'GQ', e: '🇬🇶' },
  { n: 'Eritrea', d: '+291', c: 'ER', e: '🇪🇷' },
  { n: 'Estonia', d: '+372', c: 'EE', e: '🇪🇪' },
  { n: 'Ethiopia', d: '+251', c: 'ET', e: '🇪🇹' },
  { n: 'Falkland Islands (Malvinas)', d: '+500', c: 'FK', e: '🇫🇰' },
  { n: 'Faroe Islands', d: '+298', c: 'FO', e: '🇫🇴' },
  { n: 'Fiji', d: '+679', c: 'FJ', e: '🇫🇯' },
  { n: 'Finland', d: '+358', c: 'FI', e: '🇫🇮' },
  { n: 'France', d: '+33', c: 'FR', e: '🇫🇷' },
  { n: 'French Guiana', d: '+594', c: 'GF', e: '🇬🇫' },
  { n: 'French Polynesia', d: '+689', c: 'PF', e: '🇵🇫' },
  { n: 'Gabon', d: '+241', c: 'GA', e: '🇬🇦' },
  { n: 'Gambia', d: '+220', c: 'GM', e: '🇬🇲' },
  { n: 'Georgia', d: '+995', c: 'GE', e: '🇬🇪' },
  { n: 'Germany', d: '+49', c: 'DE', e: '🇩🇪' },
  { n: 'Ghana', d: '+233', c: 'GH', e: '🇬🇭' },
  { n: 'Gibraltar', d: '+350', c: 'GI', e: '🇬🇮' },
  { n: 'Greece', d: '+30', c: 'GR', e: '🇬🇷' },
  { n: 'Greenland', d: '+299', c: 'GL', e: '🇬🇱' },
  { n: 'Grenada', d: '+1473', c: 'GD', e: '🇬🇩' },
  { n: 'Guadeloupe', d: '+590', c: 'GP', e: '🇬🇵' },
  { n: 'Guam', d: '+1671', c: 'GU', e: '🇬🇺' },
  { n: 'Guatemala', d: '+502', c: 'GT', e: '🇬🇹' },
  { n: 'Guernsey', d: '+44', c: 'GG', e: '🇬🇬' },
  { n: 'Guinea', d: '+224', c: 'GN', e: '🇬🇳' },
  { n: 'Guinea-Bissau', d: '+245', c: 'GW', e: '🇬🇼' },
  { n: 'Guyana', d: '+595', c: 'GY', e: '🇬🇾' },
  { n: 'Haiti', d: '+509', c: 'HT', e: '🇭🇹' },
  { n: 'Holy See (Vatican City State)', d: '+379', c: 'VA', e: '🇻🇦' },
  { n: 'Honduras', d: '+504', c: 'HN', e: '🇭🇳' },
  { n: 'Hong Kong', d: '+852', c: 'HK', e: '🇭🇰' },
  { n: 'Hungary', d: '+36', c: 'HU', e: '🇭🇺' },
  { n: 'Iceland', d: '+354', c: 'IS', e: '🇮🇸' },
  { n: 'India', d: '+91', c: 'IN', e: '🇮🇳' },
  { n: 'Indonesia', d: '+62', c: 'ID', e: '🇮🇩' },
  { n: 'Iran', d: '+98', c: 'IR', e: '🇮🇷' },
  { n: 'Iraq', d: '+964', c: 'IQ', e: '🇮🇶' },
  { n: 'Ireland', d: '+353', c: 'IE', e: '🇮🇪' },
  { n: 'Isle of Man', d: '+44', c: 'IM', e: '🇮🇲' },
  { n: 'Israel', d: '+972', c: 'IL', e: '🇮🇱' },
  { n: 'Italy', d: '+39', c: 'IT', e: '🇮🇹' },
  { n: 'Jamaica', d: '+1876', c: 'JM', e: '🇯🇲' },
  { n: 'Japan', d: '+81', c: 'JP', e: '🇯🇵' },
  { n: 'Jersey', d: '+44', c: 'JE', e: '🇯🇪' },
  { n: 'Jordan', d: '+962', c: 'JO', e: '🇯🇴' },
  { n: 'Kazakhstan', d: '+7', c: 'KZ', e: '🇰🇿' },
  { n: 'Kenya', d: '+254', c: 'KE', e: '🇰🇪' },
  { n: 'Kiribati', d: '+686', c: 'KI', e: '🇰🇮' },
  { n: "Korea, Democratic People's Republic of", d: '+850', c: 'KP', e: '🇰🇵' },
  { n: 'Korea, Republic of', d: '+82', c: 'KR', e: '🇰🇷' },
  { n: 'Kuwait', d: '+965', c: 'KW', e: '🇰🇼' },
  { n: 'Kyrgyzstan', d: '+996', c: 'KG', e: '🇰🇬' },
  { n: 'Laos', d: '+856', c: 'LA', e: '🇱🇦' },
  { n: 'Latvia', d: '+371', c: 'LV', e: '🇱🇻' },
  { n: 'Lebanon', d: '+961', c: 'LB', e: '🇱🇧' },
  { n: 'Lesotho', d: '+266', c: 'LS', e: '🇱🇸' },
  { n: 'Liberia', d: '+231', c: 'LR', e: '🇱🇷' },
  { n: 'Libya', d: '+218', c: 'LY', e: '🇱🇾' },
  { n: 'Liechtenstein', d: '+423', c: 'LI', e: '🇱🇮' },
  { n: 'Lithuania', d: '+370', c: 'LT', e: '🇱🇹' },
  { n: 'Luxembourg', d: '+352', c: 'LU', e: '🇱🇺' },
  { n: 'Macao', d: '+853', c: 'MO', e: '🇲🇴' },
  { n: 'Macedonia', d: '+389', c: 'MK', e: '🇲🇰' },
  { n: 'Madagascar', d: '+261', c: 'MG', e: '🇲🇬' },
  { n: 'Malawi', d: '+265', c: 'MW', e: '🇲🇼' },
  { n: 'Malaysia', d: '+60', c: 'MY', e: '🇲🇾' },
  { n: 'Maldives', d: '+960', c: 'MV', e: '🇲🇻' },
  { n: 'Mali', d: '+223', c: 'ML', e: '🇲🇱' },
  { n: 'Malta', d: '+356', c: 'MT', e: '🇲🇹' },
  { n: 'Marshall Islands', d: '+692', c: 'MH', e: '🇲🇭' },
  { n: 'Martinique', d: '+596', c: 'MQ', e: '🇲🇶' },
  { n: 'Mauritania', d: '+222', c: 'MR', e: '🇲🇷' },
  { n: 'Mauritius', d: '+230', c: 'MU', e: '🇲🇺' },
  { n: 'Mayotte', d: '+262', c: 'YT', e: '🇾🇹' },
  { n: 'Mexico', d: '+52', c: 'MX', e: '🇲🇽' },
  { n: 'Micronesia', d: '+691', c: 'FM', e: '🇫🇲' },
  { n: 'Moldova', d: '+373', c: 'MD', e: '🇲🇩' },
  { n: 'Monaco', d: '+377', c: 'MC', e: '🇲🇨' },
  { n: 'Mongolia', d: '+976', c: 'MN', e: '🇲🇳' },
  { n: 'Montenegro', d: '+382', c: 'ME', e: '🇲🇪' },
  { n: 'Montserrat', d: '+1664', c: 'MS', e: '🇲🇸' },
  { n: 'Morocco', d: '+212', c: 'MA', e: '🇲🇦' },
  { n: 'Mozambique', d: '+258', c: 'MZ', e: '🇲🇿' },
  { n: 'Myanmar', d: '+95', c: 'MM', e: '🇲🇲' },
  { n: 'Namibia', d: '+264', c: 'NA', e: '🇳🇦' },
  { n: 'Nauru', d: '+674', c: 'NR', e: '🇳🇷' },
  { n: 'Nepal', d: '+977', c: 'NP', e: '🇳🇵' },
  { n: 'Netherlands', d: '+31', c: 'NL', e: '🇳🇱' },
  { n: 'Netherlands Antilles', d: '+599', c: 'AN', e: '🇦🇳' },
  { n: 'New Caledonia', d: '+687', c: 'NC', e: '🇳🇨' },
  { n: 'New Zealand', d: '+64', c: 'NZ', e: '🇳🇿' },
  { n: 'Nicaragua', d: '+505', c: 'NI', e: '🇳🇮' },
  { n: 'Niger', d: '+227', c: 'NE', e: '🇳🇪' },
  { n: 'Nigeria', d: '+234', c: 'NG', e: '🇳🇬' },
  { n: 'Niue', d: '+683', c: 'NU', e: '🇳🇺' },
  { n: 'Norfolk Island', d: '+672', c: 'NF', e: '🇳🇫' },
  { n: 'Northern Mariana Islands', d: '+1670', c: 'MP', e: '🇲🇵' },
  { n: 'Norway', d: '+47', c: 'NO', e: '🇳🇴' },
  { n: 'Oman', d: '+968', c: 'OM', e: '🇴🇲' },
  { n: 'Pakistan', d: '+92', c: 'PK', e: '🇵🇰' },
  { n: 'Palau', d: '+680', c: 'PW', e: '🇵🇼' },
  { n: 'Palestinian Territory', d: '+970', c: 'PS', e: '🇵🇸' },
  { n: 'Panama', d: '+507', c: 'PA', e: '🇵🇦' },
  { n: 'Papua New Guinea', d: '+675', c: 'PG', e: '🇵🇬' },
  { n: 'Paraguay', d: '+595', c: 'PY', e: '🇵🇾' },
  { n: 'Peru', d: '+51', c: 'PE', e: '🇵🇪' },
  { n: 'Philippines', d: '+63', c: 'PH', e: '🇵🇭' },
  { n: 'Pitcairn', d: '+872', c: 'PN', e: '🇵🇳' },
  { n: 'Poland', d: '+48', c: 'PL', e: '🇵🇱' },
  { n: 'Portugal', d: '+351', c: 'PT', e: '🇵🇹' },
  { n: 'Puerto Rico', d: '+1939', c: 'PR', e: '🇵🇷' },
  { n: 'Qatar', d: '+974', c: 'QA', e: '🇶🇦' },
  { n: 'Romania', d: '+40', c: 'RO', e: '🇷🇴' },
  { n: 'Russia', d: '+7', c: 'RU', e: '🇷🇺' },
  { n: 'Rwanda', d: '+250', c: 'RW', e: '🇷🇼' },
  { n: 'Reunion', d: '+262', c: 'RE', e: '🇷🇪' },
  { n: 'Saint Barthelemy', d: '+590', c: 'BL', e: '🇧🇱' },
  {
    n: 'Saint Helena, Ascension and Tristan Da Cunha',
    d: '+290',
    c: 'SH',
    e: '🇸🇭',
  },
  { n: 'Saint Kitts and Nevis', d: '+1869', c: 'KN', e: '🇰🇳' },
  { n: 'Saint Lucia', d: '+1758', c: 'LC', e: '🇱🇨' },
  { n: 'Saint Martin', d: '+590', c: 'MF', e: '🇲🇫' },
  { n: 'Saint Pierre and Miquelon', d: '+508', c: 'PM', e: '🇵🇲' },
  { n: 'Saint Vincent and the Grenadines', d: '+1784', c: 'VC', e: '🇻🇨' },
  { n: 'Samoa', d: '+685', c: 'WS', e: '🇼🇸' },
  { n: 'San Marino', d: '+378', c: 'SM', e: '🇸🇲' },
  { n: 'Sao Tome and Principe', d: '+239', c: 'ST', e: '🇸🇹' },
  { n: 'Saudi Arabia', d: '+966', c: 'SA', e: '🇸🇦' },
  { n: 'Senegal', d: '+221', c: 'SN', e: '🇸🇳' },
  { n: 'Serbia', d: '+381', c: 'RS', e: '🇷🇸' },
  { n: 'Seychelles', d: '+248', c: 'SC', e: '🇸🇨' },
  { n: 'Sierra Leone', d: '+232', c: 'SL', e: '🇸🇱' },
  { n: 'Singapore', d: '+65', c: 'SG', e: '🇸🇬' },
  { n: 'Slovakia', d: '+421', c: 'SK', e: '🇸🇰' },
  { n: 'Slovenia', d: '+386', c: 'SI', e: '🇸🇮' },
  { n: 'Solomon Islands', d: '+677', c: 'SB', e: '🇸🇧' },
  { n: 'Somalia', d: '+252', c: 'SO', e: '🇸🇴' },
  { n: 'South Africa', d: '+27', c: 'ZA', e: '🇿🇦' },
  { n: 'South Sudan', d: '+211', c: 'SS', e: '🇸🇸' },
  {
    n: 'South Georgia and the South Sandwich Islands',
    d: '+500',
    c: 'GS',
    e: '🇬🇸',
  },
  { n: 'Spain', d: '+34', c: 'ES', e: '🇪🇸' },
  { n: 'Sri Lanka', d: '+94', c: 'LK', e: '🇱🇰' },
  { n: 'Sudan', d: '+249', c: 'SD', e: '🇸🇩' },
  { n: 'Suriname', d: '+597', c: 'SR', e: '🇸🇷' },
  { n: 'Svalbard and Jan Mayen', d: '+47', c: 'SJ', e: '🇸🇯' },
  { n: 'Swaziland', d: '+268', c: 'SZ', e: '🇸🇿' },
  { n: 'Sweden', d: '+46', c: 'SE', e: '🇸🇪' },
  { n: 'Switzerland', d: '+41', c: 'CH', e: '🇨🇭' },
  { n: 'Syria', d: '+963', c: 'SY', e: '🇸🇾' },
  { n: 'Taiwan', d: '+886', c: 'TW', e: '🇹🇼' },
  { n: 'Tajikistan', d: '+992', c: 'TJ', e: '🇹🇯' },
  { n: 'Tanzania', d: '+255', c: 'TZ', e: '🇹🇿' },
  { n: 'Thailand', d: '+66', c: 'TH', e: '🇹🇭' },
  { n: 'Timor-Leste', d: '+670', c: 'TL', e: '🇹🇱' },
  { n: 'Togo', d: '+228', c: 'TG', e: '🇹🇬' },
  { n: 'Tokelau', d: '+690', c: 'TK', e: '🇹🇰' },
  { n: 'Tonga', d: '+676', c: 'TO', e: '🇹🇴' },
  { n: 'Trinidad and Tobago', d: '+1868', c: 'TT', e: '🇹🇹' },
  { n: 'Tunisia', d: '+216', c: 'TN', e: '🇹🇳' },
  { n: 'Turkey', d: '+90', c: 'TR', e: '🇹🇷' },
  { n: 'Turkmenistan', d: '+993', c: 'TM', e: '🇹🇲' },
  { n: 'Turks and Caicos Islands', d: '+1649', c: 'TC', e: '🇹🇨' },
  { n: 'Tuvalu', d: '+688', c: 'TV', e: '🇹🇻' },
  { n: 'Uganda', d: '+256', c: 'UG', e: '🇺🇬' },
  { n: 'Ukraine', d: '+380', c: 'UA', e: '🇺🇦' },
  { n: 'United Arab Emirates', d: '+971', c: 'AE', e: '🇦🇪' },
  { n: 'United Kingdom', d: '+44', c: 'GB', e: '🇬🇧' },
  { n: 'United States', d: '+1', c: 'US', e: '🇺🇸' },
  { n: 'Uruguay', d: '+598', c: 'UY', e: '🇺🇾' },
  { n: 'Uzbekistan', d: '+998', c: 'UZ', e: '🇺🇿' },
  { n: 'Vanuatu', d: '+678', c: 'VU', e: '🇻🇺' },
  { n: 'Venezuela', d: '+58', c: 'VE', e: '🇻🇪' },
  { n: 'Vietnam', d: '+84', c: 'VN', e: '🇻🇳' },
  { n: 'Virgin Islands, British', d: '+1284', c: 'VG', e: '🇻🇬' },
  { n: 'Virgin Islands, U.S.', d: '+1340', c: 'VI', e: '🇻🇮' },
  { n: 'Wallis and Futuna', d: '+681', c: 'WF', e: '🇼🇫' },
  { n: 'Yemen', d: '+967', c: 'YE', e: '🇾🇪' },
  { n: 'Zambia', d: '+260', c: 'ZM', e: '🇿🇲' },
  { n: 'Zimbabwe', d: '+263', c: 'ZW', e: '🇿🇼' },
];
